import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'admin' },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  {
    path: 'fc-demo',
    canMatch: [() => !environment.production],
    loadComponent: () =>
      import('./components/pages/fc-timers-demo/fc-timers-demo.component').then(m => m.FcTimersDemoComponent),
  },
  // Página que Recall renderiza como Output Media del bot de Eva Sparring. Pública a propósito
  // (sin guard): se autentica con el token efímero `?t=` hacia /api/v2/sparring/bot.
  // Antes del catch-all ':id' del candidato.
  {
    path: 'sparring-bot/:sessionId',
    loadComponent: () =>
      import('./sparring-bot/sparring-bot-page.component').then(m => m.SparringBotPageComponent),
  },
  // Rutas del candidato (auth, maintenance-screen, process/*, catch-all ':id').
  // path:'' + loadChildren mantiene las mismas URLs de hoy; debe ir DESPUÉS de
  // 'admin' y 'fc-demo' para que el catch-all ':id' que trae adentro no las intercepte.
  //
  // Todas las rutas de candidato viven en un único NgModule (mismo chunk), así
  // que no hace falta preloadingStrategy para proteger transiciones internas
  // (auth -> :id, etc.) — ya están en el mismo chunk que se cargó desde la
  // primera página. No usamos PreloadAllModules a propósito: precargaría
  // también el chunk de admin en cada sesión de candidato (y viceversa),
  // yendo en contra del objetivo de aligerar el bundle inicial.
  { path: '', loadChildren: () => import('./candidate-exam/candidate-exam.module').then(m => m.CandidateExamModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
